import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { forbidExtraProps } from 'airbnb-prop-types';
import * as userSelectors from 'dux/user/selectors';
import * as featureFlagsSelector from 'dux/featureFlags/selectors';
import * as authSelectors from 'dux/auth/selectors';
import * as routerSelectors from 'dux/router/selectors';
import find from 'lodash/fp/find';
import {
  getFirstActiveGiftWithPurchaseBannerData,
  getIsGiftWithPurchaseBannerActive,
} from 'dux/giftWithPurchase/selectors';
import * as Banners from './Banners';

const bannersByPriority = [
  Banners.loading, // Loading needs to be first
  Banners.vanityUrlDailypop,
  Banners.giftWithPurchase,
  Banners.membershipCheckout,
  Banners.referralCta,
  Banners.membershipCta,
  Banners.noFreeShippingContent,
  Banners.supplementsPages,
  Banners.defaultBanner, // Default needs to be last
];

const Banner = ({
  canSubscribe,
  canSubscribeAtCart,
  hasNoFreeShipping,
  haveSubscription,
  hideBannerLink,
  isAuthenticated,
  isAuthenticating,
  isFlagsDoneFetching,
  isGiftWithPurchaseEligible,
  locationPathname,
  showVanityUrl,
  giftWithPurchaseBannerData,
}) => {
  const foundBanner = find(({ shouldRender }) =>
    shouldRender({
      isAuthenticated,
      canSubscribe,
      canSubscribeAtCart,
      hasNoFreeShipping,
      haveSubscription,
      isFlagsDoneFetching,
      isGiftWithPurchaseEligible,
      locationPathname,
      showVanityUrl,
      giftWithPurchaseBannerData,
    })
  )(bannersByPriority);

  if (foundBanner) {
    return foundBanner.render(
      hideBannerLink || isAuthenticating || !isAuthenticated || haveSubscription || !canSubscribe,
      { giftWithPurchaseBannerData }
    );
  }
  return null;
};

Banner.propTypes = forbidExtraProps({
  canSubscribe: PropTypes.bool,
  canSubscribeAtCart: PropTypes.bool,
  hasNoFreeShipping: PropTypes.bool,
  haveSubscription: PropTypes.bool,
  hideBannerLink: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  isAuthenticating: PropTypes.bool,
  isFlagsDoneFetching: PropTypes.bool,
  isGiftWithPurchaseEligible: PropTypes.bool,
  locationPathname: PropTypes.string.isRequired,
  showVanityUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  giftWithPurchaseBannerData: PropTypes.shape({
    lp_images: PropTypes.shape({
      mobile: PropTypes.string,
      tablet: PropTypes.string,
      desktop: PropTypes.string,
    }),
    lp_cta_text: PropTypes.string,
    lp_cta_url: PropTypes.string,
    lp_gift_description: PropTypes.string,
    lp_legal_text: PropTypes.string,
    lp_title: PropTypes.string,
    banner_color: PropTypes.string,
    banner_redirection_url: PropTypes.string,
    banner_text: PropTypes.string,
  }),
});

Banner.defaultProps = {
  canSubscribe: false,
  canSubscribeAtCart: false,
  hasNoFreeShipping: false,
  haveSubscription: false,
  hideBannerLink: false,
  isAuthenticated: false,
  isAuthenticating: true,
  isFlagsDoneFetching: false,
  isGiftWithPurchaseEligible: false,
  showVanityUrl: false,
  giftWithPurchaseBannerData: null,
};

// Name to be changed
export const StatelessBanner = Banner;

export default connect(
  state => ({
    canSubscribe: userSelectors.getCanSubscribe(state),
    canSubscribeAtCart: userSelectors.getCanSubscribeAtCart(state),
    haveSubscription: userSelectors.getHaveActiveSubscription(state),
    isAuthenticated: authSelectors.getIsAuthenticated(state),
    isAuthenticating: authSelectors.getIsAuthenticating(state),
    isFlagsDoneFetching: featureFlagsSelector.isFlagsDoneFetching(state),
    locationPathname: routerSelectors.getPathname(state),
    isGiftWithPurchaseEligible: getIsGiftWithPurchaseBannerActive(state),
    giftWithPurchaseBannerData: getFirstActiveGiftWithPurchaseBannerData(state),
    hasNoFreeShipping: routerSelectors.hasNoFreeShipping(state),
    showVanityUrl: featureFlagsSelector.shouldShowVanityUrlDailypopBanner(state),
  }),
  {}
)(Banner);
